import React, { useCallback } from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/react'

import { toggleVideo } from '../../../../webrtc/blocs/videoMuting'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'
import { useOpenDeviceSelector } from '../../../../Devices/components/DeviceSelector/DeviceSelector'
import { changeSelectedDevices } from '../../../../Devices/useDevices'

export const Camera = () => {
  const openDeviceSelector = useOpenDeviceSelector()
  const localParticipant = useLocalParticipant()
  const isMuted = !localParticipant?.tracks.camera?.isEnabled

  const getTooltipContent = useCallback(() => {
    return isMuted
      ? intl.formatMessage({ defaultMessage: 'Your camera is turned off' })
      : intl.formatMessage({ defaultMessage: 'Click to turn off your camera' })
  }, [isMuted])

  type ButtonColor = HTMLTtButtonElement['color']

  const getAriaLabel = useCallback(() => {
    return isMuted
      ? intl.formatMessage({ defaultMessage: 'Click to turn on your camera' })
      : intl.formatMessage({ defaultMessage: 'Click to turn off your camera' })
  }, [isMuted])

  const buttonColor: ButtonColor = isMuted ? 'danger' : 'primary'
  const iconName = isMuted ? 'camera-off' : 'camera-on'

  const onToggleVideo = useCallback(async () => {
    if (!localParticipant?.tracks?.camera) {
      const devicesSelected = await openDeviceSelector()
      changeSelectedDevices(devicesSelected)
    } else {
      await toggleVideo()
    }
  }, [localParticipant?.tracks?.camera, openDeviceSelector])

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton
        circle
        onClick={onToggleVideo}
        color={buttonColor}
        aria-label={getAriaLabel()}
      >
        <TtIcon library="one/webinars" name={iconName} />
      </TtButton>
    </TtTooltip>
  )
}
